// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: var(--admin-border-subtle);
  border-radius: var(--admin-radius-lg);
  background: var(--admin-bg-surface-1);
}

.au-table {
  width: 100%;
  min-width: 640px;
  border-collapse: separate;
  border-spacing: 0;
}

.au-table thead tr {
  background: rgba(255, 255, 255, 0.02);
}

.au-table tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.015);
}

.au-table-wrap--keyboard-nav [data-admin-row-selected="true"] {
  outline: 1px solid rgba(255, 255, 255, 0.12);
  outline-offset: -1px;
  background: rgba(158, 202, 255, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,qCAAqC;AACvC","sourcesContent":[".au-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  border: var(--admin-border-subtle);\n  border-radius: var(--admin-radius-lg);\n  background: var(--admin-bg-surface-1);\n}\n\n.au-table {\n  width: 100%;\n  min-width: 640px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.au-table thead tr {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.au-table tbody tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.015);\n}\n\n.au-table-wrap--keyboard-nav [data-admin-row-selected=\"true\"] {\n  outline: 1px solid rgba(255, 255, 255, 0.12);\n  outline-offset: -1px;\n  background: rgba(158, 202, 255, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
